import { types as t, IAnyModelType } from '@invisr/mobx-state-tree'
import SalesforceDataSource from './salesforce'
import JSDataSource from './javascript'
import ClientRoutesConfig from './clientRoutes'
import JSONConfig from './JsonConfig'
import UserDataSource from './user'
import EpicorDataSource from './epicor/epicor'
import EmailerDataSource from './emailer'
import UsersDataSource from './users'
import CredentialsDataSource from './credentials'
import WhereUsed from './where-used'
import DSDeps from './datasource-dependencies'
import JsonApiDataSource, { defaultRequestMapping } from './json-api'
import WebSocket from './websocket'
import State from './state'
import DataStore from './data-store'
import Files from './files'
import Twilio from './twilio'
import S4HANA from './saps4hana'
import DynamoDB from './dynamodb'
import FnDataSource from './function'
import Docusign from './docusign'
import { DatabaseDataSource } from './database'
import OpenAPIDatasource from './openApi'
import Notifications from './notifications/notifications';
import Toasts from './toasts';
import StackContext from './stackContext'
import { GenericDataSource, default as DataSourceType } from './datasource-type'

const operationalContext = t.model({})
  .volatile(self => ({
      isOperationInProgress: false
  }))
  .actions(self => ({
    setIsOperationInProgress(value) {
      self.isOperationInProgress = value;
    }
}))

let dataSourceTypeMap = {
  Salesforce: SalesforceDataSource,
  S4HANA: t.compose(
    'S4HANA',
    WhereUsed,
    DSDeps,
    S4HANA
  ),
  'Client Routes': ClientRoutesConfig,
  JSON: JSONConfig.preProcessSnapshot(snap => {
    if (typeof snap.json !== 'string') {
      return { ...snap, json: '{}' }
    }
    return snap
  }),
  User: UserDataSource,
  Epicor: EpicorDataSource,
  Emailer: EmailerDataSource,
  Credentials: CredentialsDataSource,
  Users: UsersDataSource,
  JavaScript: JSDataSource,
  Function: t.compose(
    FnDataSource,
    operationalContext
  ),
  'JSON-API': JsonApiDataSource
    .preProcessSnapshot(snap => {
      if (snap.mapping) return snap
      const s = { request: undefined, ...snap }
      if (s.request) {
        const defMapping = JSON.parse(JSON.stringify(defaultRequestMapping))
        s.mapping = {
          ...defMapping,
          children: [...defMapping.children]
        }
        Object.keys(s.request).forEach(k => {
          const c = s.mapping.children.find(c => c.key === k)
          if (c) {
            c.bindingType = 'value'
            c.value = s.request[k]
          }
        })
      }
      return s
    }),
  WebSocket,
  Files,
  DataStore,
  Toasts,
  Twilio,
  State: State
    .preProcessSnapshot(s => {
      const snap = { items: undefined, ...s }
      if (snap.items) {
        snap.items = snap.items.map(item => {
          if (typeof item === 'string') return { name: item }
          return item
        })
      }
      return snap
    }),
  DynamoDB,
  Docusign,
  Database: DatabaseDataSource,
  OpenAPI: OpenAPIDatasource,
  Notifications: t.compose(
    Notifications,
    operationalContext
  ),
  StackContext
}

Object.keys(dataSourceTypeMap).forEach(k => {
  dataSourceTypeMap[k] = t.compose(dataSourceTypeMap[k], DataSourceType)
})

export const dataSourceTypes = Object.keys(dataSourceTypeMap)
const DataSource = t.union(
  {
    dispatcher: (snapshot: { type: keyof typeof dataSourceTypeMap}) => dataSourceTypeMap[snapshot.type] ?? GenericDataSource
  },
  ...Object.values(dataSourceTypeMap),
  GenericDataSource
)

export default DataSource
